/**
 * London Smoke & Cure — Njord RTDB URL and admin key from build env.
 */

export function getNjordRtdbUrl() {
    const raw = process.env.REACT_APP_NJORD_RTDB_URL || '';
    return typeof raw === 'string' ? raw.trim().replace(/\/$/, '') : '';
}

export function getNjordCloudRunUrl() {
    const raw = process.env.REACT_APP_NJORD_CLOUD_RUN_URL || '';
    return typeof raw === 'string' ? raw.trim().replace(/\/$/, '') : '';
}

export function getNjordAdminApiKey() {
    const raw = process.env.REACT_APP_NJORD_ADMIN_API_KEY || '';
    return typeof raw === 'string' ? raw.trim() : '';
}

export function isNjordConfigured() {
    return Boolean(getNjordRtdbUrl() && getNjordCloudRunUrl());
}

export function njordAdminHeaders() {
    const key = getNjordAdminApiKey();
    const h = { Accept: 'application/json' };
    if (key) h['X-Njord-Admin-Key'] = key;
    return h;
}
